import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgFxSurfaceComponent } from './surface.component';
import { NgFxSliderModule } from './../slider/slider.module';
import { NgFxButtonModule } from './../button/button.module';
export { NgFxSurfaceComponent } from './surface.component';
var NgFxSurfaceModule = (function () {
    function NgFxSurfaceModule() {
    }
    NgFxSurfaceModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, NgFxSliderModule, NgFxButtonModule],
                    declarations: [NgFxSurfaceComponent],
                    exports: [NgFxSurfaceComponent]
                },] },
    ];
    return NgFxSurfaceModule;
}());
export { NgFxSurfaceModule };
